import React from "react";
import { useState } from "react";
import TableBody from "../../../components/core/table/components/table-body";
import TableHead from "../../../components/core/table/components/table-head";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NavLink } from "react-router-dom";
import { classNames } from "primereact/utils";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button, Table } from "../../../components/core";
import OverLayTable from "./overLay-table";

export default function DropOffTable({
  className,
  headers = [
    {
      header_name: "Column 1",
      header_key: "column1",
    },
    {
      header_name: "Column 2",
      header_key: "column2",
    },
  ],
  items = [
    {
      column1: "Column 2",
      column2: "Column 2",
    },
  ],
  children,
  linkName,
  linkBody,
  fieldId,
  actionColumn,
  bottomAction,
  dt,
}) {
  const [pastItem, setPastItem] = React.useState([]);
  const withLinkTemplate = (rowData) => {
    return (
      <NavLink
        to={`${linkBody}/${rowData[fieldId]}`}
        className={"text-component-blueTextColor"}
      >
        {rowData[linkName]}
      </NavLink>
    );
  };

  //rowColors
  const rowClassName = (rowData) => {
    if (rowData.status === "Claimed") {
      return "bg-green-300 border border-black";
    } else if (rowData.status === "Revoked") {
      return "bg-red-300 border border-black";
    } else if (rowData.status === "Removed") {
      return "bg-gray-300 border border-black";
    } else if (rowData.status === "Pending") {
      return "bg-yellow-300 border border-black";
    } else if (rowData.status === "For Collect") {
      return "bg-blue-300 border border-black";
    } else if (rowData.status === "Revoked") {
      return "bg-red-300 border border-black";
    } else if (rowData.status === "Cancelled") {
      return "bg-amber-400 border border-black";
    }
    return "border border-black";
  };

  const overlayRef = React.createRef();
  const [overlayVisible, setOverlayVisible] = useState(false);

  const showOverlay = (event) => {
    overlayRef.current.toggle(event);
    setOverlayVisible(true);
  };

  const hideOverlay = () => {
    overlayRef.current.hide();
    setOverlayVisible(false);
  };
  const actionButton = (rowData) => {
    return (
      <div>
        <Button
          className={"w-20"}
          value={"History"}
          onClick={(e) => {
            setPastItem(
              items.filter(
                (x) => rowData.packageId === x.packageId && x.history === "Past"
              )
            );
            showOverlay(e);
          }}
        />
        <OverlayPanel
          ref={overlayRef}
          closeOnEscape
          onHide={hideOverlay}
          appendTo={document.body}
          visible={overlayVisible}
        >
          <div className={" text-right pb-1"}>
            <Button
              className={"ml-auto w-6 bg-red-500 text-white mr-2"}
              value={"x"}
              onClick={hideOverlay}
            />
          </div>

          <OverLayTable
            headers={[
              {
                header_name: "Locker Name",
                header_key: "locker",
              },
              {
                header_name: "Waybill Number",
                header_key: "waybill",
              },
              {
                header_name: "Recipient",
                header_key: "recipient",
              },
              {
                header_name: "Drop-Off",
                header_key: "dropoff",
              },
              {
                header_name: "Status",
                header_key: "status",
              },
              {
                header_name: "Status Date",
                header_key: "statusDate",
              },
              {
                header_name: "Hrs Elapsed",
                header_key: "elapsedHrs",
              },
              {
                header_name: "Courier",
                header_key: "courier",
              },
              {
                header_name: "History",
                header_key: "history",
              },
            ]}
            items={pastItem}
          />
        </OverlayPanel>
      </div>
    );
  };
  return (
    <DataTable
      value={items.filter((x) => x.history === "Present")}
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="Rows per page"
      paginator
      paginatorRight
      rowsPerPageOptions={[10, 20, 50]}
      rows={10}
      sortMode="multiple"
      removableSort
      rowClassName={rowClassName}
      exportFilename="Dropoff Status and History Report"
      showGridlines
      tableStyle={{
        minWidth: "50rem",
        borderWidth: 2,
        borderColor: "#E6E6E6",
      }}
      emptyMessage={<div></div>}
      ref={dt}
      cellSelection={true}
      onCellClick={(e) => {
        if (e.field == "waybill") {
          window.open(
            `/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.userId}`,
            "_blank"
          );
        }
        if (e.field == "courier") {
          window.open(
            `/operator/admin/agents/agentProfile/${e.rowData.agentId}`,
            "_blank"
          );
        }
        if (e.field == "recipient") {
          window.open(
            `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.userAccountId}`,
            "_blank"
          );
        }
      }}
    >
      {headers.map((data, key) => {
        // console.log(linkName, data.header_key);
        if (data.header_key == "blank") {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              style={{ display: "none" }}
            ></Column>
          );
        }
        if (linkBody && linkName === data.header_key) {
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              body={withLinkTemplate}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if ("actionButton" === data.header_key) {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              exportHeader="  "
              body={actionButton}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if (data.header_key == "recipient") {
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              className="font-blue cursor-pointer font-bold"
              body={formatDate1}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if (data.header_key == "courier") {
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              className="font-blue cursor-pointer font-bold"
              body={formatDate2}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if (data.header_key == "waybill") {
          return (
            <Column
              field={data.header_key}
              sortable
              className="font-blue cursor-pointer font-bold"
              header={data.header_name}
              body={removeSecondA}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
          ></Column>
        );
      })}
    </DataTable>
  );
}
const formatDate1 = (e) => {
  return e.recipient.toString().substring(2);
};

const formatDate2 = (e) => {
  return e.courier.toString().substring(2);
};
const removeSecondA = (e) => {
  if (e.waybill.length < 2) {
    return e.waybill;
  }
  if (e.waybill.charAt(1) === "*") {
    return e.waybill.slice(0, 1) + e.waybill.slice(2);
  }
  return e.waybill;
};
